module.exports = __webpack_public_path__ + "static/media/2.c259e0e3.png";